export default __webpack_public_path__ + "static/media/fileBlankIcon.10eb72f9.svg";